import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { SparklesIcon, BriefcaseIcon, ShoppingCartIcon, UserIcon, HeartIcon } from 'lucide-react';
const nodes = [{
  icon: SparklesIcon,
  title: 'Conciencia',
  description: 'El fundamento de todo'
}, {
  icon: BriefcaseIcon,
  title: 'Negocio',
  description: 'Estructura que genera'
}, {
  icon: ShoppingCartIcon,
  title: 'Ecommerce',
  description: 'Ventas que escalan'
}, {
  icon: UserIcon,
  title: 'Marca Personal',
  description: 'Autoridad que atrae'
}, {
  icon: HeartIcon,
  title: 'Alma',
  description: 'Expansión que sostiene'
}];
export function TransformationMap() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 md:py-32 bg-beige" data-id="element-286">
      <div className="max-w-6xl mx-auto px-6" data-id="element-287">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-16 md:mb-20" data-id="element-288">
          <p className="font-sans text-sm uppercase tracking-widest text-gold mb-4" data-id="element-289">
            El sistema
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-6" data-id="element-290">
            El Sistema de Transformación
          </h2>
          <p className="font-sans text-lg text-charcoal-mid font-light max-w-xl mx-auto" data-id="element-291">
            No son cursos. Es un ecosistema integrado.
          </p>
        </motion.div>

        {/* Desktop horizontal layout */}
        <div className="hidden md:block relative" data-id="element-292">
          {/* Connecting line */}
          <motion.div initial={{
          scaleX: 0
        }} animate={isInView ? {
          scaleX: 1
        } : {}} transition={{
          duration: 1.5,
          delay: 0.5,
          ease: 'easeOut'
        }} className="absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-gold/20 via-gold to-gold/20 -translate-y-1/2 origin-left" style={{
          top: '60px'
        }} data-id="element-293" />

          <div className="grid grid-cols-5 gap-4" data-id="element-294">
            {nodes.map((node, index) => <motion.div key={node.title} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.3 + index * 0.2,
            ease: 'easeOut'
          }} className="relative flex flex-col items-center text-center" data-id="element-295">
                <div className="w-28 h-28 rounded-full bg-white shadow-lg flex items-center justify-center mb-6 relative z-10" data-id="element-296">
                  <node.icon className="w-10 h-10 text-gold" data-id="element-297" />
                </div>
                <h3 className="font-serif text-xl text-charcoal mb-2" data-id="element-298">
                  {node.title}
                </h3>
                <p className="font-sans text-sm text-charcoal-mid" data-id="element-299">
                  {node.description}
                </p>
              </motion.div>)}
          </div>
        </div>

        {/* Mobile vertical layout */}
        <div className="md:hidden relative" data-id="element-300">
          {/* Connecting line */}
          <motion.div initial={{
          scaleY: 0
        }} animate={isInView ? {
          scaleY: 1
        } : {}} transition={{
          duration: 1.5,
          delay: 0.5,
          ease: 'easeOut'
        }} className="absolute left-10 top-0 bottom-0 w-0.5 bg-gradient-to-b from-gold/20 via-gold to-gold/20 origin-top" data-id="element-301" />

          <div className="flex flex-col gap-8" data-id="element-302">
            {nodes.map((node, index) => <motion.div key={node.title} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.3 + index * 0.15,
            ease: 'easeOut'
          }} className="relative flex items-center gap-6" data-id="element-303">
                <div className="w-20 h-20 rounded-full bg-white shadow-lg flex items-center justify-center flex-shrink-0 relative z-10" data-id="element-304">
                  <node.icon className="w-8 h-8 text-gold" data-id="element-305" />
                </div>
                <div data-id="element-306">
                  <h3 className="font-serif text-xl text-charcoal mb-1" data-id="element-307">
                    {node.title}
                  </h3>
                  <p className="font-sans text-sm text-charcoal-mid" data-id="element-308">
                    {node.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}